import { CreateClassificationMutationProvider } from "__legacy/queries/classifications/CreateClassificationMutationProvider";
import { IndustryQueryProvider } from "__legacy/queries/industries/IndustryQueryProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { CodeForm, onError, onFinish } from "./CodeForm";

export const New: React.FC<{}> = () => {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <IndustryQueryProvider variables={{ id: groupId }}>
      {({ industry }) => (
        <CreateClassificationMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`New classification code for ${industry.name}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../../")}>Back to list</Button>
                    <Button onClick={() => navigate("../../")}>Back to industry</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <CodeForm
                  action="create"
                  form={form}
                  handler={onFinish(mutate, { industryId: groupId }, {})}
                  values={{}}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </CreateClassificationMutationProvider>
      )}
    </IndustryQueryProvider>
  );
};
